// hooks/useNotifier.ts
import { useSnackbar, VariantType } from "notistack";

type NotifyOptions = {
  message: string;
  variant?: VariantType; // 'default' | 'error' | 'success' | 'warning' | 'info'
  autoHideDuration?: number;
};

export const useNotifier = () => {
  const { enqueueSnackbar } = useSnackbar();

  const notify = ({
    message,
    variant = "default",
    autoHideDuration = 3000,
  }: NotifyOptions) => {
    enqueueSnackbar(message, { variant, autoHideDuration });
  };

  return { notify };
};
